import styled from "styled-components";

interface IBubbleTooltipContainerBoxProps {
  zIndex: number;
  fontSize?: string;
  lineHeight?: string;
}

export const BubbleTooltipContainerDefaultBox = styled.div<IBubbleTooltipContainerBoxProps>`
@keyframes TooltipAppearAnimation {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  
  display: flex;
  align-items: center;

  z-index: ${props => props.zIndex};
  
  background: ${({ theme }) => theme.colors.backgroundMiddleDark};
  color: ${({ theme }) => theme.colors.textLight};
  
  border-color: ${({ theme }) => theme.colors.boxBorderContrast};
  border-width: 1px;
  border-style: solid;
  border-radius: 8px;
  
  font-size: ${({fontSize}) => fontSize ? fontSize : '1.6rem'};
  font-weight: 500;
  line-height: ${({lineHeight}) => lineHeight ? lineHeight : '1.6rem'};
  padding: 10px 14px;
  
  //Arrow spacing configuration
  &[data-popper-placement^='top'] > #tool-tip-container-arrow {
    bottom: -7px;
    &:before { transform: rotate(225deg) };
  }
  
  &[data-popper-placement^='bottom'] > #tool-tip-container-arrow {
    top: -7px;
    &:before { transform: rotate(45deg) };
  }
  
  &[data-popper-placement^='left'] > #tool-tip-container-arrow {
    right: -7px;         
    &:before { transform: rotate(135deg) }; //180 - 45
  }
  
  &[data-popper-placement^='right'] > #tool-tip-container-arrow {
    left: -7px;         
    &:before { transform: rotate(315deg) }; //360 - 45
  }
`;
